export interface ApiResultModel<T> {
  isSuccess: boolean;
  code: number;
  pageInfo: PageInfoModel;
  autoClose: any;
  messages: string[];
  data: T;
}

export class PageInfoModel {
  total!: number;
  pageSize: number = 10;
  pageNumber!: number;
}

export class ColumnModel {
  id: string | undefined;
  label: string | undefined;
  hasFormat?: boolean = false;
  isSpan?: boolean = false;
  spanClass?: (value: string) => string;
  format?: (value: any) => string;
}

export interface ShellConfig {
  comment: string;
  headerTitleColor: string;
  mainheaderTitleColor: string;
  headerTitle: string;
  mainHeaderTitle: string;
  companyName: string;
  sidemenueLogo: string;
  asideMenuColor: string;
  mainColor: string;
  defualtColor: string;
  defualtColor_100: string;
  defualtColor_200: string;
  secondColor: string;
  secondColor_100: string;
  secondColor_200: string;
  secondColor_300: string;
  secondColor_400: string;
  secondColor_500: string;
  secondColorClass: string;
  selectedAsideMenuColor: string;
  favIcon: string;
  loginLogo: string;
  loginTitle: string;
  muiColor: string;
  badgeColor: string;
  muiSelected: string;
  sideMenuLogoCollapsed: string;
}
export interface IList {
  parentId: number;
  childId: number;
}
